
  import ImageHeader from '@/components/core/ImageHeader';
  import NoContent from '@/components/customer-content/NoContent'
  import CheckoutModal from '@/components/modals/CheckoutModal';
  export default {
    layout: 'error-page',
    components: {
      NoContent,
      ImageHeader,
      CheckoutModal,
    },
    head() {
      return {
        title: this.title,
        meta: [{
        hid: "description",
        name: "description",
        content: this.description,
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "restaurant near me, veg restaurant near me, near me restaurant, goa restaurant, best restaurants in goa, restaurants in goa, top 10 restaurants in goa, famous restaurants in goa, top restaurants in goa, pure veg restaurants in goa",
      },
      {
        hid: "og:title",
        property: "og:title",
        content: this.title,
      },
      {
        hid: "og:description",
        property: "og:description",
        content: this.description,
      },
      {
        hid: "twitter:title",
        property: "twitter:title",
        content: this.title,
      },
      {
        hid: "twitter:description",
        property: "twitter:description",
        content: this.description,
      },
      { hid: 'og:image:alt',
        property: 'og:image:alt',
        content: this.title ? this.title : 'Goa App'
      },
      { hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/meta-imgs/dining-meta-image.webp'
      },
      { hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/meta-imgs/dining-meta-image.webp'
      },
      { hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/meta-imgs/dining-meta-image.webp'
      }
        ],
      }
    },
    data() {
      return {
        title: 'Restaurant Deals & Offers in Goa | Flat 20% OFF Discount Coupon',
        description: "Looking for a best restaurant in Goa? Need Amazing Discounts and Offers? Visit Goa App now & Unlock special restaurant offers and redeem them now!",
        cartDetails: null,
        cartItems: null,
        loading: true,
        token: null,
        selectedCartItem: 0,
        deleteCartItem: {
          loading: false,
          success: false,
          formError: null,
          errored: false
        },
        //ALL OFFERS
        skip: 0,
        page: 1,
        totalNumberOfpages: 0,
        listings: {},
        itemCartSelected: -1,
        busy: false,
        productObj: [],
        initialLoading: true,
        addToCartLoading: false,
        toBeAddedToCart: null,
        activiteStatesList: [],
        listingLoading: true,
        offerCount: null
      };
    },
    // Check login token
    mounted() {

      if (localStorage.getItem("authToken") != (null || undefined)) {
        this.token = localStorage.getItem("authToken");
        this.getCartDetails();
      }
      this.getListings()
      this.getStatesData();
    },
    methods: {

      // ------------------------ DROPDOWN CITY LIST METHODS -----------------------
      async getStatesData() {
        this.activiteStatesList = await fetch(this.$config.fetchUrl + '/api/offers/getCitiesWithOffers/')
          .then(res => res.text());
        this.activiteStatesList = this.getCryptKey(this.activiteStatesList);
      },

      resetListObj() {
        this.listings = null;
        this.productObj.length = 0;
      },

      // ------------------------ DROPDOWN CITY LIST METHODS END-----------------------

      getTermsArr(terms) {
        let arr = terms.split("\n")
        arr = arr.filter(item => item);
        return arr
      },

      showOfferItem(item) {
        if (localStorage.getItem("authToken") != (null || undefined)) {
          if (this.cartItems && this.cartItems.length > 0) {
            const found = this.cartItems.some(el => el.offer._id === item._id);
            if (found) return false
            return true
          }
          return true
        } else {
          return true
        }
      },

      getOfferCount(){
        if(this.$el){
        const el = this.$el.getElementsByClassName('offer-count-func');
        if(el){
          this.offerCount = el.length;
        }
      }
      },

      // ------------------------ INFINITE PAGINATION METHODS -----------------------

      getListings(skip = 0, city = null) {
        let headerData = null;
        let url = '/api/offers/getAllOffers';
        if (localStorage.getItem("authToken") != (null || undefined)) {
          this.token = localStorage.getItem("authToken");
          headerData = {
            "Content-Type": "application/x-www-form-urlencoded",
            'Authorization': this.token,
          };
          url = '/api/offers/getAllOffersForUser'
        } else {
          headerData = {
            "Content-Type": "application/x-www-form-urlencoded",
          };
        }
        // Add header for the API
        const headers = headerData;
        var formData = new URLSearchParams();
        formData.append("skip", skip);
        if (city) {
          formData.append("city", city);
        }

        this.$axios.post(url, formData, {
            headers: headers
          })
          .then(response => {
            let value = this.getCryptKey(response.data);
            this.productObj.push(...value.offers)
            this.listings = value;
            this.initialLoading = false;
            if (skip == 0) {
              this.page = 1;
            }
            this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 10);
            this.$nextTick(() => {
            this.busy = false;
            this.listingLoading = false;
          });
          })
          .finally(() => {
            this.$nextTick(() => {
              this.busy = false;
              this.listingLoading = false;
              this.getOfferCount();
            })
          })
      },

      loadMore() {
        this.busy = false;
        if (this.listings.isMoreDataAvailable) {
          this.busy = true;
          setTimeout(() => {
            this.page++
            this.callback(this.page)
          }, 1000);
        }
      },

      // callback for the pagination plugin
      callback: function (page) {
        this.page = page;
       //this.storeFilters();
        let pagination = (page - 1) * 10;
        if (pagination < 0) {
          pagination = 0;
        }
        this.getListings(pagination);
      },

      // ------------------------ INFINITE PAGINATION METHODS END-----------------------


      //----------------------- LOGIN POP UP FUNCTIONS -----------------------------------

      userCreated() {
        // this.offerLoading = true;
        this.listings = null;
        this.productObj.length = 0;
        this.getListings(0);
        if (this.toBeAddedToCart)
          this.addOfferToCart(this.toBeAddedToCart)
      },

      //----------------------- LOGIN POP UP FUNCTIONS ENDS-------------------------------


      //------------------------------------------- CART FUNCTIONS -------------------------------------------//

      // TO get CART DETAILS
      getCartDetails() {
        this.loading = true;
        var formData = new URLSearchParams();
        // Add header for the API
        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          'Authorization': this.token
        };
        // AXIOS api call to add review api
        this.$axios.post("/api/offerCarts/getMyOfferCart", formData, {
            headers: headers
          })
          .then(response => {
            let value = this.getCryptKey(response.data);
            this.cartDetails = value;
            this.cartItems = this.cartDetails.offerCartItems;
            this.$nextTick(() => {
              this.getOfferCount();
            })
          })
          .catch(error => {
            this.$nextTick(() => {
              this.$router.push({
                path: '/'
              })
              this.loading = false;
            })
          })
          .finally(() => {
            this.$nextTick(() => {
              this.loading = false;
            })
          })
      },

      deleteFromCart(id) {
        // Clear all submit errors before API call
        this.deleteCartItem.formError = null;
        this.deleteCartItem.success = false;
        this.deleteCartItem.errored = false;
        this.deleteCartItem.loading = true;
        // Add header for the API
        const headers = {
          "Content-Type": "application/JSON",
          'Authorization': this.token
        };
        this.$axios.delete("/api/offerCarts/" + id, {
            headers: headers
          })
          .then(response => {
            let value = this.getCryptKey(response.data);
            this.deleteCartItem.success = true;
            this.deleteCartItem.errored = false;
            this.cartDetails = value;
            this.cartItems = this.cartDetails.offerCartItems;
            if (this.cartItems && this.cartItems.length > 0) {
              this.getCartDetails();
              this.$nextTick(() => {
              this.getOfferCount();
            })
            } else {
              // this.$router.push({
              //   path: '/'
              // })
            }
          })
          .catch(error => {
            this.deleteCartItem.success = false;
            this.deleteCartItem.errored = true;
          })
          .finally(() => {
            this.deleteCartItem.loading = false;
          })
      },

      addOfferToCart(item) {
        if (localStorage.getItem("authToken") != (null || undefined)) {
          this.addToCartLoading = true
          // Create formData instance to pass the data to the API
          var formData = new URLSearchParams();
          formData.append("offer", item._id);
          // Add header for the API
          const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': this.token
          }
          // AXIOS api call to add categories api
          this.$axios
            .post(`/api/offerCarts/app/v2/addToOfferCart`, formData, {
              headers: headers
            })
            .then(response => {
              this.toBeAddedToCart = null;
              let value = this.getCryptKey(response.data);
              this.addToCartLoading = false;
              this.getCartDetails();
              this.$nextTick(() => {
              this.getOfferCount();
            })
            })
            .catch(error => {
              this.addToCartLoading = false;
              localStorage.clear();
              this.$router.push({
                path: "/accounts/login"
              });

            })
            .finally(() => {
              this.addToCartLoading = false;
            });

        } else {
          this.toBeAddedToCart = item;
          this.$bvModal.show('checkout')
        }
      },

      goToCheckout() {
        this.$router.push({
          path: '/offers-checkout'
        })
      },
      //------------------------------------------- CART FUNCTIONS END-------------------------------------------//
    }
  }
